import React from 'react';
import PropTypes from 'prop-types';

import {
  Display,
  Header,
  Content,
  Footer,
  HardwareButtonWrapper
} from 'containers';

import { Text, HeaderText } from 'components';
import { DisplayButton } from 'components/buttons';

const Exit = ({ text, destinations }) => {
  const buttonConfig = {
    left: {
      destination: destinations.left
    },
    center: {
      destination: destinations.center || 'default'
    },
    right: {
      destination: destinations.right
    }
  };

  return [
    <Display key="display">
      <Header>
        <HeaderText value={text} />
      </Header>
      <Content>
        <Text />
      </Content>
      <Footer>
        <DisplayButton src="icon-xm-left-arrow" />
        <DisplayButton src="icon-xm-enter" />
        <DisplayButton src="icon-xm-right-arrow" />
      </Footer>
    </Display>,
    <HardwareButtonWrapper key="buttons" config={buttonConfig} />
  ];
};

Exit.propTypes = {
  text: PropTypes.string.isRequired,
  destinations: PropTypes.shape({
    left: PropTypes.string.isRequired,
    center: PropTypes.string,
    right: PropTypes.string.isRequired
  }).isRequired
};

export default Exit;



// WEBPACK FOOTER //
// ./src/screens/shared/Exit/Exit.js